<template>
  <div>
    <v-toolbar flat color="white">
      <v-toolbar-title>İzinlerim</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn color="primary" dark @click="openCreateDialog">
        <v-icon left>event_available</v-icon>
        İzin Talep Et
      </v-btn>
    </v-toolbar>

    <v-data-table
      :headers="headers"
      :items="requests"
      :loading="loading"
      :rows-per-page-items="[25, 50, { text: 'Tümü', value: -1 }]"
      class="elevation-1"
    >
      <template v-slot:items="props">
        <td class="px-2">{{ formatDate(props.item.startDate) }}</td>
        <td class="px-2">{{ formatDate(props.item.endDate) }}</td>
        <td class="px-2 text-xs-right">{{ props.item.dayCount }}</td>
        <td class="px-2">{{ props.item.reason || '-' }}</td>
        <td class="px-2">
          <v-chip small :color="statusColor(props.item.status)" text-color="white">{{ props.item.statusText }}</v-chip>
        </td>
        <td class="px-2">
          <span v-if="props.item.decidedByName">{{ props.item.decidedByName }} · {{ formatDateTime(props.item.decidedDate) }}</span>
          <span v-else>-</span>
        </td>
        <td class="px-2">{{ props.item.adminNote || '-' }}</td>
        <td class="px-2">
          <v-btn v-if="props.item.status === 0" small flat color="red" :loading="cancellingId === props.item.id" @click="cancelRequest(props.item)">
            <v-icon small left>close</v-icon>
            İptal
          </v-btn>
        </td>
      </template>
      <template v-slot:no-data>
        <div class="text-xs-center pa-4 grey--text">Henüz izin talebiniz yok.</div>
      </template>
    </v-data-table>

    <v-dialog v-model="createDialog" max-width="480" persistent>
      <v-card>
        <v-card-title class="headline primary white--text">
          <v-icon left color="white">event_available</v-icon>
          İzin Talebi
        </v-card-title>
        <v-card-text class="pa-4">
          <v-radio-group v-model="form.rangeMode" row hide-details class="mt-0 mb-3">
            <v-radio label="Tek Gün" :value="false"></v-radio>
            <v-radio label="Tarih Aralığı" :value="true"></v-radio>
          </v-radio-group>

          <v-menu v-model="startMenu" :close-on-content-click="false" max-width="290">
            <template v-slot:activator="{ on }">
              <v-text-field
                :value="form.startDate"
                :label="form.rangeMode ? 'Başlangıç Tarihi' : 'İzin Tarihi'"
                prepend-icon="event"
                readonly
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker v-model="form.startDate" locale="tr-TR" :min="today" @input="startMenu = false"></v-date-picker>
          </v-menu>

          <v-menu v-if="form.rangeMode" v-model="endMenu" :close-on-content-click="false" max-width="290">
            <template v-slot:activator="{ on }">
              <v-text-field
                :value="form.endDate"
                label="Bitiş Tarihi"
                prepend-icon="event"
                readonly
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker v-model="form.endDate" locale="tr-TR" :min="form.startDate || today" @input="endMenu = false"></v-date-picker>
          </v-menu>

          <v-textarea
            v-model="form.reason"
            label="Açıklama / Sebep"
            rows="2"
            counter="500"
            maxlength="500"
          ></v-textarea>
        </v-card-text>
        <v-card-actions class="pa-3">
          <v-spacer></v-spacer>
          <v-btn text color="grey" @click="createDialog = false">Vazgeç</v-btn>
          <v-btn color="primary" dark :loading="saving" @click="save">
            <v-icon left>send</v-icon>
            Talep Gönder
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  data: () => ({
    loading: false,
    saving: false,
    cancellingId: null,
    requests: [],
    createDialog: false,
    startMenu: false,
    endMenu: false,
    form: { rangeMode: false, startDate: null, endDate: null, reason: "" },
    headers: [
      { text: "Başlangıç", value: "startDate" },
      { text: "Bitiş", value: "endDate" },
      { text: "Gün", value: "dayCount", align: "right" },
      { text: "Sebep", value: "reason", sortable: false },
      { text: "Durum", value: "status" },
      { text: "Karar", value: "decidedByName", sortable: false },
      { text: "Yönetici Notu", value: "adminNote", sortable: false },
      { text: "", value: "actions", sortable: false },
    ],
  }),

  computed: {
    today() {
      return new Date().toISOString().slice(0, 10);
    },
  },

  async created() {
    await this.load();
  },

  methods: {
    formatDate(d) {
      if (!d) return "-";
      return new Date(d).toLocaleDateString("tr-TR");
    },
    formatDateTime(d) {
      if (!d) return "";
      return new Date(d).toLocaleString("tr-TR");
    },
    statusColor(status) {
      if (status === 0) return "orange darken-2";
      if (status === 1) return "green";
      if (status === 2) return "red";
      return "grey";
    },
    async load() {
      this.loading = true;
      try {
        this.requests = (await this.$store.dispatch("leaves/getMyRequests")) || [];
      } catch (e) {
        this.$store.state.dialog = true;
        this.$store.state.message = "İzinler yüklenemedi: " + this.errMsg(e);
      } finally {
        this.loading = false;
      }
    },
    errMsg(e) {
      return (e.response && e.response.data && e.response.data.message) || e.message || "bilinmeyen hata";
    },
    openCreateDialog() {
      this.form = { rangeMode: false, startDate: null, endDate: null, reason: "" };
      this.createDialog = true;
    },
    async save() {
      if (!this.form.startDate) {
        this.$store.state.dialog = true;
        this.$store.state.message = "Tarih seçin.";
        return;
      }
      if (this.form.rangeMode && !this.form.endDate) {
        this.$store.state.dialog = true;
        this.$store.state.message = "Bitiş tarihi seçin.";
        return;
      }
      this.saving = true;
      try {
        await this.$store.dispatch("leaves/create", {
          startDate: this.form.startDate,
          endDate: this.form.rangeMode ? this.form.endDate : this.form.startDate,
          reason: this.form.reason,
        });
        this.createDialog = false;
        this.$store.state.dialog = true;
        this.$store.state.message = "İzin talebiniz gönderildi.";
        await this.load();
      } catch (e) {
        this.$store.state.dialog = true;
        this.$store.state.message = "Talep gönderilemedi: " + this.errMsg(e);
      } finally {
        this.saving = false;
      }
    },
    async cancelRequest(item) {
      if (!confirm("Bu izin talebi iptal edilsin mi?")) return;
      this.cancellingId = item.id;
      try {
        await this.$store.dispatch("leaves/cancel", item.id);
        await this.load();
      } catch (e) {
        this.$store.state.dialog = true;
        this.$store.state.message = "İptal edilemedi: " + this.errMsg(e);
      } finally {
        this.cancellingId = null;
      }
    },
  },
};
</script>
